<!-- Web version -->
<div class="equipment-detail-info" *ngIf="!mobile">
  <div class="equipment-info">
    <div class="equipment-info-title">
      <span>{{ 'equipment.equipment-menu-item' | translate }}</span>
    </div>

    <ng-container *ngIf="!!showEquipmentRequest();">
      <div [loadModule]="showEquipmentRequest()"
           [loadInputs]="{inputs: [{ prop: 'mobile', value: mobile, setInput: true }]}">
      </div>
    </ng-container>

    <dx-accordion #accordion [dataSource]="selectedItem.equipment" [collapsible]="true" [multiple]="false"
      [animationDuration]="300" id="accordion-container">
      <div *dxTemplate="let item of 'title'">
        <div class="equipment-header">
          <div class="equipment-header-label">{{ 'equipment.equipment-name' | translate }}:</div>
          <div class="equipment-header-value">{{ item.posName }}</div>
        </div>
      </div>
      <div *dxTemplate="let item of 'item'">
        <div class="equipment-details">
          <div class="equipment-item">
            <div class="equipment-item-label">{{ 'equipment.equipment-barcode' | translate }}:</div>
            <div class="equipment-item-value">{{ item.barcode }}</div>
          </div>
          <div class="equipment-item">
            <div class="equipment-item-label">{{ 'equipment.date-of-first-install' | translate }}:</div>
            <div class="equipment-item-value">{{ item.firstInstallDate | date: 'dd.MM.yyyy' }}</div>
          </div>
        </div>
      </div>
    </dx-accordion>
  </div>
</div>


<!-- Mobile version -->
<div class="equipment-detail-info" *ngIf="mobile">
  <div class="equipment-info">
    <div class="title-mobile" *ngIf="showContent">
      <i class="icon icon-equipment"></i>
      <span>{{ 'equipment.equipment-menu-item' | translate }}</span>
    </div>

    <ng-container *ngIf="!!showEquipmentRequest();">
      <div [loadModule]="showEquipmentRequest()"
           [loadInputs]="{inputs: [{ prop: 'mobile', value: mobile, setInput: true }]}">
      </div>
    </ng-container>

    <dx-accordion *ngIf="showContent" #accordion [dataSource]="selectedItem.equipment" [collapsible]="true" [multiple]="false"
      [animationDuration]="300" id="accordion-container">
      <div *dxTemplate="let item of 'title'">
        <div class="equipment-header">
          <div class="equipment-header-label">{{ 'equipment.equipment-name' | translate }}:</div>
          <div class="equipment-header-value">{{ item.posName }}</div>
        </div>
      </div>
      <div *dxTemplate="let item of 'item'">
        <div class="equipment-details">
          <div class="equipment-item">
            <div class="equipment-item-label">{{ 'equipment.equipment-barcode' | translate }}:</div>
            <div class="equipment-item-value">{{ item.barcode }}</div>
          </div>
          <div class="equipment-item">
            <div class="equipment-item-label">{{ 'equipment.date-of-first-install' | translate }}:</div>
            <div class="equipment-item-value">{{ item.firstInstallDate | date: 'dd.MM.yyyy' }}</div>
          </div>
        </div>
      </div>
    </dx-accordion>
  </div>
</div>
